<template>
    <div @click="pullAppEn()">Please use a browser to open</div>
</template>

<script>
export default {
    data: function() {
        return {

        };
    },
    mounted() {
        this.pullAppEn();
    },
}
</script>